<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      @hide="onModalHide"
      :title="$t('workflow.processField.fill')"
    >
      <div v-if="model">
        <h3>{{ model.processName }}</h3>

        <b-row>
          <b-col cols="7">
            <label for="select-status">
              <b-row>
                <b-col>Status</b-col>
                <b-col class="required">*</b-col>
              </b-row>
            </label>
            <b-input-group>
              <b-form-select
                id="select-status"
                class="status"
                :options="options"
                v-model="statusId"
                @input="getStageField"
              >
              </b-form-select>
            </b-input-group>
          </b-col>
        </b-row>
        <span class="text-danger" v-if="modelstate['StatusId']">
          {{ modelstate["StatusId"][0] }}
        </span>
        <!-- {{ model.values }} -->
        <div v-for="field in model.values" :key="field.fieldId">
          <workflow-fill-field
            :field="field"
            :fieldId="field.fieldId"
            :modelstate="modelstate"
            :stage="false"
          >
          </workflow-fill-field>
        </div>
        <!-- Campos adicionais da etapa -->

        <div v-for="field in model.additionalFields" :key="field.fieldId">
          <!-- {{ model }} -->
          <workflow-fill-field
            :field="field"
            :fieldId="field.fieldId"
            :modelstate="modelstate"
            :stage="true"
          >
          </workflow-fill-field>
        </div>
      </div>

      <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->

      <template #modal-footer="{}">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="onModalHide()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <base-dialog-confirm
      ref="confirm"
      @confirm="hideModal"
      @cancel="show"
      :message="'Sair sem salvar?'"
      :title="'Salvar processo'"
    >
    </base-dialog-confirm>
  </b-container>
</template>
<script>
export default {
  name: "WorkflowFillModal",
  props: {
    id: String,
  },
  components: {
    WorkflowFillField: () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
    BaseDialogConfirm: () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      model: null,
      submitted: false,
      options: [],
      statusId: null,
      modelstate: {},
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
      this.getProcess();
    },
    getOptions() {
      this.$apiWorkflow.get("/stage/allStage/" + this.id).then((response) => {
        this.options = response.data;
        if (this.options.length > 0) {
          this.statusId = this.options[0].value;
        }
      });
    },
    getProcess() {
      this.$apiWorkflow
        .get(`/processFilled/new/${this.id}`)
        .then((response) => {
          this.model = response.data;
          this.getOptions();
          this.getPosition();
          // this.getField();
        });
    },
    getAdditionalFields() {
      this.$apiWorkflow
        .get("/stage/addtionalFields/" + this.statusId + "/" + this.id)
        .then((response) => {
          this.model.additionalFields = response.data;
          this.$forceUpdate();
        });
    },
    async save() {
      this.submitted = true;
      await this.$apiWorkflow
        .post("/fieldValue/save/", this.model)
        .then((response) => {
          this.submitted = false;
          this.alert.success = "Processo criado com sucesso!"; //data.data.message;
          this.$refs.alert.show();
          this.$emit("refreshData");
          this.model = null;
          this.options = [];
          this.additionalFields = [];
          this.statusId = null;
          this.hideModal();
        })
        .catch((error) => {
          this.submitted = false;
          console.log(error);
          console.log(error.response);
          console.log(error.response.data);

          this.modelstate = {};
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.submitted = false;
            if (error.response) {
              if (error.response.status == 400) {
                console.log("error.response.status == 400 3");
                console.log(error.response.data);
                console.log(error.response.data.errors);
                if (
                  !error.response.data.errors ||
                  error.response.data.errors === undefined
                ) {
                  this.alert.error = error.response.data;
                } else {
                  this.modelstate = error.response.data.errors;
                  this.alert.error = "Verifique os valores informados";
                }
              } else if (error.response.status == 500) {
                console.log("error.response.status == 500");
                console.log(error);
                console.log(error.response);
                console.log(error.response.data);
                if (error.response.data) {
                  console.log(error.response.data.errors);
                }
                if (error.response.data) {
                  this.alert.error = error.response.data.detail;
                } else {
                  this.alert.error = `${error.response.status} - ${error.response.data.detail} `;
                }
              } else {
                console.log(error);
                console.log(error.response);
                console.log(error.response.data);
                if (error.response.data) {
                  console.log(error.response.data.errors);
                }
                if (error.response.data) {
                  this.alert.error = error.response.data.errors;
                } else {
                  this.alert.error = `${error.response.status} - ${error.response.statusText} `;
                }
              }
            } else {
              console.log(error);
              console.log(error.response);
              console.log(error.response.data);
              if (error.response.data) {
                console.log(error.response.data.errors);
              }
              this.alert.error = error.message;
            }
            this.$refs.danger.show();
          }
        });
      this.submitted = false;
    },
    getPosition() {
      navigator.geolocation.getCurrentPosition(this.success, this.error);
    },
    success(pos) {
      if (!this.model) return;
      var crd = pos.coords;
      this.model.latitude = crd.latitude;
      this.model.longitude = crd.longitude;
    },
    error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    },
    getField() {
      this.$apiWorkflow
        .get("/processFilled/getFields/" + this.id)
        .then((response) => {
          this.model.values = response.data;
        });
    },
    getStageField() {
      this.model.statusId = this.statusId;
      if (this.statusId != null) {
        this.getAdditionalFields();
      }
    },
    hideModal() {
      // this.model.additionalFields = [];
      this.model = null;
      this.options = [];
      this.additionalFields = [];
      this.statusId = null;
      // this.getStageField();
      // this.$forceUpdate();
      this.$refs.openModal.hide();
    },
    onModalHide() {
      let showModal = false;
      if (this.model) {
        let totalFields = this.model.additionalFields.length;
        for (let i = 0; i < totalFields; i++) {
          if (this.model.additionalFields[i].value != "") {
            showModal = true;
            break;
          }
        }
      }
      if (showModal) this.$refs.confirm.show();
      else this.hideModal();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>